import React, {Component, Fragment} from 'react';
import moment from 'moment';
import { withRouter} from 'react-router-dom'
import {  withSnackbar } from 'notistack';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle,  Grid, TextField, Tooltip } from '@material-ui/core';
import MomentUtils from '@date-io/moment';
import EditIcon from '@material-ui/icons/Edit';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import { errorCodeClaim, claimObj } from '..';
import { fieldDateFormat, backendDateFormat, assetType } from '../../../constants';
import { fieldValidation } from '../../../utils/formValidation';
import { regexConstants} from '../../../constants/regEx';
import {addAttachmentApi, addEditAssemblyClaimApi, deleteAttachmentApi, getCashflowApi, getEngineModuleConstant, } from '../apiServices';
import {checkApiStatus} from '../../../utils';
import { trackActivity } from '../../../utils/mixpanel';
import { CustomChip, CustomDropzone,  DeletePopUp,  PageLoader,  PreviewDocsModal } from '../../../shared_elements';
import {  globalGetService,  } from '../../../utils/globalApiServices';

class AddEditClaim extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal:false,
      mode:'',
      claim: {},
      error:{},
      heading:'',
      previewDocs:"",
      deleteAttachmentModal: false,
      deleteItem: "",
      attachedDoc:[],
      pageLoader :false,
      buttonLoader :false,
      moduleList:[],
      moduleConstantList : [],
      amountErrors:{},
      shopVisitEvent:{},
      editAmount : {},
      showDateError: false,
      dateErrorMsg: "",
    }
    this.addEditAssemblyClaimApi = addEditAssemblyClaimApi.bind(this)
    this.addAttachmentApi = addAttachmentApi.bind(this);
    this.deleteAttachmentApi = deleteAttachmentApi.bind(this);
    this.getEngineModuleConstant = getEngineModuleConstant.bind(this);
    this.getCashflowApi = getCashflowApi.bind(this);
  }
  componentDidMount(){
    this.setState({
      claim: this.props.claimObj
    })  
  }
  updateErrorField = (key, message) => {
    this.setState(prevState => ({
      ...prevState,
      error: {
        ...prevState.error,
        [key]: message
      },
      amountErrors: {
        ...prevState.amountErrors,
        [key]: message
      }
    }))
  }
  onFieldChange = (event, keyParam, data, type) => {
    if (type === "module") {
      this.setState(prevState => ({
        ...prevState,
        claim: {
          ...prevState.claim,
          prsv_claim_amount: {
            ...prevState.claim.prsv_claim_amount,
            [keyParam]: data
          }
        }
      }))
    } else if (keyParam === "submission_date") {
      this.setState(prevState => ({
        ...prevState,
        claim: {
          ...prevState.claim,
          [keyParam]: data,
          period_extend_reason: ""
        }
      }))
    } else {
      this.setState(prevState => ({
        ...prevState,
        claim: {
          ...prevState.claim,
          [keyParam]: data
        }
      }))
    }
  }

  addEditClaim = () => {
    const {claim,attachedDoc,moduleList,shopVisitEvent} = this.state
    const {event,getShopVisitResponseBack} = this.props
    const expiryDate = moment(event?.shop_visit_date).add(event?.claim_approval_period, "days").format("YYYY-MM-DD");
    const errors = {};
    moduleList?.forEach(item => {
      const val = claim?.prsv_claim_amount && claim?.prsv_claim_amount[item.label];
      if (shopVisitEvent.prsv && !val || shopVisitEvent.prsv && val.toString().trim() === '') {
        errors[item.label] = `${item.label} Claim Amount is required`;
      }
    });

    let validationInputs = {
      claim_amount: claim?.claim_amount || moduleList?.length>0  || ((this.props?.event?.llp_replacement || claim?.shop_visit_events?.llp_replacement) && (!this.props?.event?.prsv || !claim?.shop_visit_events?.prsv)) ? "" :  "Please enter Claim Amount",
      submission_date:errorCodeClaim['submission_date'][fieldValidation({...errorCodeClaim['submission_dateObj'], fieldval:claim.submission_date})],
      llp_claim_amount : claim?.llp_claim_amount ? "" : ((this.props.event?.asset_type === 2 && this.props.event?.llp_replacement)|| (claim?.asset_type === "engine" &&claim?.shop_visit_events?.llp_replacement)) ? "Please enter LLP Claim Amount" : "",
      period_extend_reason : moment(claim?.submission_date).isAfter(expiryDate) && !claim?.period_extend_reason?.trim() ? "Please enter Period Extension Reason as submission date exceeds validity period" : ""
    }
    if (moment(claim.submission_date).isAfter(expiryDate) && !claim.period_extend_reason) {
        this.setState({
          showDateError: true,
          dateErrorMsg:`Submission date cannot be greater than claim validity period (${expiryDate}), kindly add Period Extension Reason to proceed.`
        });
        return;
    }
    if(Object.keys(validationInputs).every((k)=>{return validationInputs[k] === ''}) && Object.keys(errors).every((k)=>{return errors[k] === ''})){
      if (attachedDoc?.length>10) {
        this.props.enqueueSnackbar('Only 10 attachment can be attached in one time.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return; 
      }
      if (attachedDoc?.length+ claim?.attachments?.length>50) {
        this.props.enqueueSnackbar('Only 50 attachment can be attached.', { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
        return; 
      }
      const numericAmountPaid = moduleList?.length>0 && claim?.prsv_claim_amount && Object.keys(claim?.prsv_claim_amount)?.length>0 ? Object.fromEntries(
        Object.entries(claim?.prsv_claim_amount)?.map(([key, value]) => [key, Number(value)])
      ):{};

      const total = Object.values(numericAmountPaid).reduce((sum, value) => sum + value, 0);
      const totalClaimAmount = Number(claim?.claim_amount || 0) + Number(claim?.llp_claim_amount || 0);
      const showClaimError = () => {
        this.props.enqueueSnackbar(`Claim exceeds shop visit limit (Max: US$${event.cost}).`, {
          variant: 'error',
          anchorOrigin: { vertical: 'top', horizontal: 'right' }
        });
      };
       if (moduleList?.length > 0 && shopVisitEvent?.llp_replacement && ( Number(total || 0) + Number(claim?.llp_claim_amount || 0) > event?.cost)){
        showClaimError();
        return;
      }else if(moduleList?.length > 0 && Number(total || 0) > event?.cost){
        showClaimError();
        return;
      }else if (shopVisitEvent?.prsv && shopVisitEvent?.llp_replacement && totalClaimAmount > event?.cost) {
        showClaimError();
        return;
      }else if(claim?.claim_amount && Number(claim.claim_amount) > event?.cost){
        showClaimError();
        return;
      }else if(shopVisitEvent?.llp_replacement && Number(claim?.llp_claim_amount || 0) && Number(claim?.llp_claim_amount || 0) > event?.cost){
        showClaimError();
        return;
      }

      this.setState({buttonLoader:true})

      this.addEditAssemblyClaimApi(this.props, {...claim,prsv_claim_amount :numericAmountPaid ? numericAmountPaid : {},llp_claim_amount : Number(claim?.llp_claim_amount), attachments:[]} )
      .then(response => {
        if(checkApiStatus(response)){
          this.setState({buttonLoader:false})

          if (attachedDoc?.length > 0) {
           this.addAttachmentApi(this.props.id ? "Claim updated successfully" : "Claim created successfully",response?.data?.data?.id, this.props, attachedDoc, "claim", this.toggleFnc);
          } else {
            this.props.enqueueSnackbar(response.data.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            this.props.getResponseBack();
            getShopVisitResponseBack()
          }
          this.setState({modal:false, mode:'', claim:{}, error:{}});
          trackActivity('Item Added / Edited', {
              page_type: 'Claims',
              page_title: 'Shop visit',
              asset_slug: this?.props?.match?.params?.assetSlug,
              asset_type: this?.props?.match?.params?.assetType,
              assembly_type: this?.props?.assemblyType,
            })
        } else {
          this.setState({buttonLoader:false})
          this.props.enqueueSnackbar(response?.data?.message, {variant:'error',anchorOrigin:{vertical:'top', horizontal:"right"}})
        }
      })
    }else{
      this.setState({error: validationInputs,amountErrors: errors })
    }
  }

  toggleFnc = (key,status)=>{
    this.setState({[key] : status})
  }

  handleRatioRateChange = (value) => {
    this.setState(prevState => ({
      ...prevState,
      claim: {
        ...prevState.claim,
        psrv_claim_module : value
      }
    }))
  };

  getModuleDescriptionApi = (params, query) => {
    const { id, claimData, event } = this.props
    this.setState({tableLoader:true})
    globalGetService(`console/v2/asset/engine/${params}/llp/`, { for_reserve_account: query })
      .then(response => {
        if (checkApiStatus(response)) {
          const updatedResponse = response?.data?.data?.map(item => ({
            label: item,
            value: `${item?.toLowerCase()}_event`
          }));
          const activeModules = updatedResponse?.filter(option => id ? (((claimData?.shop_visit_events && claimData?.shop_visit_events[option.value]) || (claimData?.shop_visit_events?.other_events &&  claimData?.shop_visit_events?.other_events[option.value]))) : ((event?.other_events &&  event?.other_events[option.value]) ||  (event && event[option.value])));
          const mergedArray = activeModules.map(item => {
            const match = this.state.moduleConstantList.find(ref => ref.label === item.label);
            return match
              ? { ...item, moduleValue: match.value, }
              : item;
          });
          this.setState({
            tableLoader: false,
            moduleList: mergedArray
          })
        }
      })
  }
  onAttachmentDelete = () => {
        this.setState(prevState =>({
          ...prevState,
          claim:{
            ...prevState.claim,
            attachments: this.state.claim?.attachments?.filter(item => item.uuid !== this.state.deleteItem.uuid)
          }
        }))
        this.deleteAttachmentApi(this.state.deleteItem,"claim",this.props.id, this.toggleFnc)
  }
  handleExpiryReason = () => {
    const {claim} = this.state
    const {event} = this.props
    const expiryDate = moment(event?.shop_visit_date).add(event?.claim_approval_period, "days").format("YYYY-MM-DD");
    if (moment(claim.submission_date).isAfter(expiryDate) && !claim.period_extend_reason?.trim()) {
      this.setState(prev => ({ error: { ...prev.error, period_extend_reason: "Please enter Period extend Reason as submission date exceeds validity period", }, showDateError: true }))
    } else {
      this.setState({ showDateError: false })
    }
  }
  render() {
    const { claim, error, modal, heading, mode,attachedDoc,moduleList,amountErrors,shopVisitEvent} =this.state
    const { id, claimData, buttonText, claimId, size, variant,shopVisitId,event} = this.props
    const expiryDate = moment(event?.shop_visit_date).add(event?.claim_approval_period, "days").format("YYYY-MM-DD");
    return (
      <Fragment>
        {id ? <Tooltip title="Edit" arrow><EditIcon
          onClick={() => {
            if (claimData?.asset_slug) {
              this.getEngineModuleConstant()
              this.getModuleDescriptionApi(claimData?.asset_slug, "module");
              this.getCashflowApi(claimData?.asset_type,claimData?.asset_slug,event?.id)
            };
            this.setState({ modal: true, mode: 'edit', heading: 'Edit Claim', claim: claimData,shopVisitEvent:{asset_type : claimData?.asset_type,  prsv : claimData?.shop_visit_events?.prsv,llp_replacement : claimData?.shop_visit_events?.llp_replacement}, error: {}, amountErrors:{} },
              () => trackActivity('Item Clicked', { page_title: 'Shop visit', item_type: 'edit', assembly_type: this.props.assemblyType }));
          }}
          color="primary" /></Tooltip> :
          <Button size={size} className="add-mr-claim" color="primary" variant={variant ? variant : "contained"} onClick={() => {
            if (event?.asset_slug) {
              this.getEngineModuleConstant()
              this.getModuleDescriptionApi(event?.asset_slug, "module");
              this.getCashflowApi(assetType[event?.asset_type],event?.asset_slug,event?.id)
            };
            this.setState({ modal: true, mode: 'add', heading: 'Add Claim', claim: { ...claimObj, shop_visit_id: parseInt(claimId ? claimId : shopVisitId) }, shopVisitEvent:{asset_type : event?.asset_type, prsv : event?.prsv,llp_replacement : event?.llp_replacement}, error: {}, amountErrors:{} }, () => trackActivity('Item Clicked', { item_type: `${mode} ${buttonText}` }))
          }}> + {buttonText}</Button>
        }
        { modal ?
          <Dialog
            open={modal}
            onClose={()=>{this.setState({modal:false, error:{},claim:{},amountErrors:{},moduleList:[]})}}
            aria-labelledby="scroll-dialog-title"
          >
            <DialogTitle id="scroll-dialog-title">
              {heading}
            </DialogTitle>
            <DialogContent dividers={true}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <MuiPickersUtilsProvider utils={MomentUtils}>
                    <KeyboardDatePicker
                       required
                       margin="normal"
                       id="start_date"
                       label="Submission Date"
                       format={fieldDateFormat}
                       fullWidth
                       InputLabelProps={{shrink: true}}
                       value={claim.submission_date ? moment(claim.submission_date):null}
                       onChange={(data, value) => this.onFieldChange(value, 'submission_date', data ? moment(data).format(backendDateFormat):data)}
                       onFocus={() => this.updateErrorField('submission_date', '')}
                       error={error.submission_date ? true: false}
                       helperText={error.submission_date ? error.submission_date :''}
                     />
                  </MuiPickersUtilsProvider>
                </Grid>
                {(shopVisitEvent?.asset_type !== 2 || shopVisitEvent?.asset_type !== "engine") && moduleList?.length === 0 &&  !shopVisitEvent?.prsv   && !shopVisitEvent?.llp_replacement ?
                  <Grid item xs={6}>
                    <TextField
                      required
                      label="Claim Amount"
                      fullWidth
                      margin="normal"
                      value={claim.claim_amount || ''}
                      onChange={e => {
                        if (regexConstants.decimalnodotstart.test(e.target.value) && e.target.value !== ".") {
                          this.onFieldChange(e, 'claim_amount', e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      onFocus={() => this.updateErrorField('claim_amount', '')}
                      error={!!error.claim_amount}
                      helperText={error.claim_amount || ''}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 10 }}
                      // variant='outlined'
                    />
                  </Grid> :((event?.asset_type !== 2 && event?.prsv) || (claim?.asset_type !== "engine" && claim?.shop_visit_events?.prsv))&& !shopVisitEvent?.llp_replacement && !moduleList?.length ?<Grid item xs={6}>
                    <TextField
                      required
                      label="Claim Amount"
                      fullWidth
                      margin="normal"
                      value={claim.claim_amount || ''}
                      onChange={e => {
                        if (regexConstants.decimalnodotstart.test(e.target.value) && e.target.value !== ".") {
                          this.onFieldChange(e, 'claim_amount', e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      onFocus={() => this.updateErrorField('claim_amount', '')}
                      error={!!error.claim_amount}
                      helperText={error.claim_amount || ''}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 10 }}
                      // variant='outlined'
                    />
                  </Grid> :null }

                {((event?.asset_type === 2 && event?.prsv) || (claim?.asset_type === "engine" && claim?.shop_visit_events?.prsv)) && !moduleList?.length ?
                  <Grid item xs={6}>
                    <TextField
                      required
                      label="PRSV Claim Amount"
                      fullWidth
                      margin="normal"
                      value={claim.claim_amount || ''}
                      onChange={e => {
                        if (regexConstants.decimalnodotstart.test(e.target.value) && e.target.value !== ".") {
                          this.onFieldChange(e, 'claim_amount', e.target.value);
                        } else {
                          e.preventDefault();
                        }
                      }}
                      onFocus={() => this.updateErrorField('claim_amount', '')}
                      error={!!error.claim_amount}
                      helperText={error.claim_amount || ''}
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ maxLength: 10 }}
                    />
                  </Grid> : null}
                
                {((event?.asset_type === 2 && event?.llp_replacement)|| (claim?.asset_type === "engine" &&claim?.shop_visit_events?.llp_replacement)) ?   
                <Grid item xs={6}>
                  <TextField
                    required
                    id="name"
                    label={ "LLP Claim Amount"}
                    fullWidth
                    margin="normal"
                    value={claim?.llp_claim_amount}
                    onChange={(e, value) =>  { regexConstants.decimalnodotstart.test(e.target.value)  ? this.onFieldChange(e, 'llp_claim_amount', e.target.value): e.preventDefault()}}
                    onFocus={()=> this.updateErrorField('llp_claim_amount', '')}
                    error={error.llp_claim_amount ? true:false }
                    helperText={error.llp_claim_amount ? error.llp_claim_amount : ''}
                    InputLabelProps={{shrink: true}}
                    inputProps={{ maxLength: 10 }}
                  />
                </Grid> :null}
                {((event?.asset_type === 2 && event?.prsv) || (claim?.asset_type === "engine" &&claim?.shop_visit_events?.prsv))  ?
                 <>
                      {moduleList?.map((module, index) => {
                        return (
                          <Grid item xs={6}>
                          <TextField
                            required
                            id="name"
                            label={`${module?.label} Claim Amount`}
                            fullWidth
                            margin="normal"
                            value={(claim?.prsv_claim_amount && claim?.prsv_claim_amount[module.label])}
                            onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value)  ?  this.onFieldChange(e, module.label, e.target.value,"module") : e.preventDefault() }}
                            onFocus={() => this.updateErrorField(module.label, '')}
                            error={amountErrors && amountErrors[module.label] ? true : false}
                            helperText={amountErrors && amountErrors[module.label] ?amountErrors[module.label]  : ''}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ maxLength: 10 }}
                          />
                          </Grid>
                        )
                      })}
                </> : null}
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Claim Details"
                    fullWidth
                    margin="normal"
                    multiline
                    rows="4"
                    value={claim.description}
                    onChange={(e, value) => this.onFieldChange(e, 'description', e.target.value)}
                    error={error.name ? true:false }
                    InputLabelProps={{shrink: true}}
                  />
                </Grid>
                {claim?.period_extend_reason?.length ?
                <Grid item xs={12}>
                  <TextField
                    required={moment(claim?.submission_date).isAfter(expiryDate)}
                    id="period_extend_reason"
                    label="Period Extension Reason"
                    fullWidth
                    margin="normal"
                    multiline
                    rows="4"
                    disabled
                    value={claim?.period_extend_reason || ""}
                    onChange={(e) => this.onFieldChange(e, "period_extend_reason", e.target.value.trimStart())}
                    onFocus={() => this.updateErrorField("period_extend_reason", "")}
                    error={!!error?.period_extend_reason}
                    helperText={error?.period_extend_reason || ""}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>:null}
                <Grid item xs={12}>
                  <TextField
                    id="name"
                    label="Remarks"
                    fullWidth
                    margin="normal"
                    multiline
                    rows="4"
                    value={claim.remarks}
                    onChange={(e, value) => this.onFieldChange(e, 'remarks', e.target.value)}
                    error={error.name ? true:false }
                    InputLabelProps={{shrink: true}}
                  />
                </Grid>
                {mode === 'view' ?
                    <div style={{ marginLeft: '8px', marginBottom: '20px' }}>
                      <p style={{ fontSize: '14px', color: 'rgb(160, 160, 160)', fontFamily: "Conv_IBMPlexSans-Regular" }}>Attachment(s) [Count: {claim?.attachments?.length}]</p>
                      {claim?.attachments?.length ? claim?.attachments && claim?.attachments.map((file, index) => (
                        <CustomChip
                          style={{ marginRight: '4px', marginTop: '7px'}}
                          title={file.name}
                          index={index}
                          label={file.name.substring(0, 14) + '...'}
                          onClick={(e) => { e.preventDefault(); e.stopPropagation();  this.setState({ previewDocs: file }) }}
                        />
                      )) : '--'}
                    </div>
                    :
                    (
                      <Grid item xs={12} style={{ marginBottom: '5px' }} className='drag-drop'>
                        <CustomDropzone
                          onChange={(files) => this.setState({ attachedDoc: files })}
                          componentData={claim}
                          attachedDoc = {attachedDoc}
                        >
                        </CustomDropzone>
                        {claim?.attachments && claim?.attachments.map((file, index) => (
                          <CustomChip
                            style={{ marginRight: '4px', marginTop: '7px'}}
                            title={file.name}
                            index={index}
                            label={file.name.substring(0, 14) + '...'}
                            onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ previewDocs: file })}}
                            onDelete={(e) => { e.preventDefault(); e.stopPropagation(); this.setState({ deleteAttachmentModal: true, deleteItem: file }); }}
                          />
                        ))}
                      </Grid>)}
              </Grid>
            </DialogContent>
            <DialogActions>
              <Button size='small'  onClick={()=> this.setState({ modal:false, error:{},claim:{}}, () => trackActivity('Item Clicked', { page_title: 'Shop Visit', page_type: 'Claims', activity_type: 'Cancel' }))} variant='outlined' className='mr-5' color="primary">Cancel</Button>
              <Button size='small' variant="contained" onClick={this.addEditClaim} color="primary">{this.state.buttonLoader ? <CircularProgress color="#ffffff" size={24} /> : "Save"}</Button>
            </DialogActions>
          </Dialog> : null
        }
        {this.state.previewDocs ? <PreviewDocsModal previewDocs={this.state.previewDocs} toggleModalFn={() => this.setState({ previewDocs: '' })} /> : null}
        {this.state.deleteAttachmentModal ?
          <DeletePopUp
          loader={this.state.buttonLoader}
            modal={this.state.deleteAttachmentModal}
            toggleModalFn={() => this.setState({ deleteAttachmentModal: false })}
            title="Delete Attachment"
            content={<h4>Are you sure you want to delete?</h4>}
            deleteRecordFn={() => this.onAttachmentDelete()}
          /> : null
        }

        {this.state.showDateError &&
        <Dialog open={this.state.showDateError} >
          <DialogTitle>Claim Validity Period Error</DialogTitle>
          <DialogContent dividers>
            <p style={{color:'red'}}>{this.state.dateErrorMsg}</p>
            <Grid>
              <Grid item xs={12}>
                <TextField
                  required={moment(claim?.submission_date).isAfter(expiryDate)}
                  id="period_extend_reason"
                  label="Period Extension Reason"
                  fullWidth
                  margin="normal"
                  multiline
                  rows="4"
                  value={claim?.period_extend_reason || ""}
                  onChange={(e) => this.onFieldChange(e, "period_extend_reason", e.target.value.trimStart())}
                  onFocus={() => this.updateErrorField("period_extend_reason", "")}
                  error={!!error?.period_extend_reason}
                  helperText={error?.period_extend_reason || ""}
                  InputLabelProps={{ shrink: true }}
                  variant='outlined'
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" size='small' onClick={() => { this.setState(prev => ({ claim: { ...prev.claim, period_extend_reason: "" }, showDateError: false }))}} color="primary" > Cancel </Button>
            <Button variant="outlined" size='small' onClick={() => { this.handleExpiryReason()}} color="primary" > Proceed </Button>
          </DialogActions>
        </Dialog>}

        {this.state.pageLoader ? <PageLoader /> :null}
      </Fragment>

    )
  }

}

export default withSnackbar(withRouter(AddEditClaim));
